/**
 * ResonanceTamer — поиск УЗКОЙ СТАЦИОНАРНОЙ грязи (металлический звон,
 * сетевой гул) и предложения точечных вырезов для авторежима мастеринга.
 *
 * Зачем: октавный автоэквалайзер не хирург — замер 10.08: резонанс +12 дБ
 * Q9 @3.5 кГц после полного авто-прогона стал ЗАМЕТНЕЕ (выпуклость
 * 3.2 → 4.6 дБ: соседние полосы режутся одинаково, а лимитер прижимает
 * соседей сильнее пика). Жалоба Pro-3450 «важно что-то поднять, а что-то
 * наоборот убрать» этим замером ПОДТВЕРДИЛАСЬ (его же «авто только
 * повышает» — опровергнуто: минусы до −8 применяются).
 *
 * Главный риск — ложные вырезы на МУЗЫКЕ: выдержанный орган/пад — тоже
 * «стационарные узкие пики». Защиты (все обязательны):
 *   1) стационарность: пик обязан жить в ≥80% окон СТРОГО в том же бине
 *      (мелодия движется, звон и гул — нет);
 *   2) гармоническая семья: есть родня на ~2f или ~3f → это тон
 *      инструмента, не трогаем;
 *   3) доминанта: пик в пределах 10 дБ от глобального максимума спектра —
 *      это ведущий голос трека, не грязь;
 *   4) потолки: максимум 3 выреза, не глубже −8 дБ, ширина Q 4..16.
 *
 * API:
 *   ResonanceTamer.analyze(buffer) → [{freq, gainDb(<0), q, promDb}]
 *   (пусто = вырезать нечего; порядок — по заметности)
 */
(function (root) {
    'use strict';

    var FRAME = 8192, HOP = 4096;
    var F_LO = 45, F_HI = 12000;        // гул 50/60/100 Гц включён
    var PROM_DB = 6;                    // минимальная выпуклость над локальным фоном
    var PRESENCE = 0.8;                 // доля окон со «своим» пиком
    var MAX_CUTS = 3, MAX_CUT_DB = 8;

    function fftReal(re) {              // in-place radix-2, |X|² первой половины
        var n = re.length, im = new Float64Array(n);
        for (var i = 1, j = 0; i < n; i++) {
            var bit = n >> 1;
            for (; j & bit; bit >>= 1) j ^= bit;
            j ^= bit;
            if (i < j) { var t = re[i]; re[i] = re[j]; re[j] = t; }
        }
        for (var len = 2; len <= n; len <<= 1) {
            var ang = -2 * Math.PI / len, wr = Math.cos(ang), wi = Math.sin(ang);
            for (i = 0; i < n; i += len) {
                var cr = 1, ci = 0;
                for (j = 0; j < len / 2; j++) {
                    var a = i + j, b = i + j + len / 2;
                    var xr = re[b] * cr - im[b] * ci, xi = re[b] * ci + im[b] * cr;
                    re[b] = re[a] - xr; im[b] = im[a] - xi;
                    re[a] += xr; im[a] += xi;
                    var ncr = cr * wr - ci * wi; ci = cr * wi + ci * wr; cr = ncr;
                }
            }
        }
        var out = new Float64Array(n / 2);
        for (i = 0; i < n / 2; i++) out[i] = re[i] * re[i] + im[i] * im[i];
        return out;
    }

    function prepareAnalysis(buffer) {
        if (!buffer || typeof buffer.getChannelData !== 'function') return null;
        var sr = buffer.sampleRate, len = buffer.length;
        if (len < FRAME * 4) return null;
        var d0 = buffer.getChannelData(0);
        var d1 = buffer.numberOfChannels > 1 ? buffer.getChannelData(1) : d0;

        var binHz = sr / FRAME;
        var loBin = Math.max(2, Math.round(F_LO / binHz));
        var hiBin = Math.min(FRAME / 2 - 2, Math.round(F_HI / binHz));
        var nFrames = Math.floor((len - FRAME) / HOP) + 1;
        if (nFrames > 200) nFrames = 200;               // достаточно и дёшево
        var step = Math.floor(((len - FRAME) / (nFrames - 1)) || HOP);

        var hits = new Int32Array(FRAME / 2);           // сколько окон дали пик в бине
        var promSum = new Float64Array(FRAME / 2);
        var meanDb = new Float64Array(FRAME / 2);       // средний спектр (для гармоник/доминанты)
        var hann = new Float64Array(FRAME);
        for (var h = 0; h < FRAME; h++) hann[h] = 0.5 - 0.5 * Math.cos(2 * Math.PI * h / (FRAME - 1));

        var frame = new Float64Array(FRAME);
        function processFrame(f) {
            var off = f * step;
            for (var i = 0; i < FRAME; i++) frame[i] = (d0[off + i] + d1[off + i]) * 0.5 * hann[i];
            var p = fftReal(frame);
            // локальный фон: медиана в окне ±1/3 октавы — грубая, но честная
            for (i = loBin; i <= hiBin; i++) {
                var db = 10 * Math.log10(p[i] + 1e-20);
                meanDb[i] += db;
                var w = Math.max(3, Math.round(i * 0.26));      // ±1/3 окт ≈ ×1.26
                var a = Math.max(loBin, i - w), b = Math.min(hiBin, i + w);
                // медиана по прореженной выборке окна (дёшево)
                var samp = [];
                for (var k = a; k <= b; k += Math.max(1, ((b - a) / 24) | 0)) samp.push(p[k]);
                samp.sort(function (x, y) { return x - y; });
                var base = 10 * Math.log10(samp[(samp.length >> 1)] + 1e-20);
                var prom = db - base;
                if (prom >= PROM_DB) {
                    // узость: соседи ±(1/8 окт) уже должны упасть на ≥3 дБ
                    var nw = Math.max(2, Math.round(i * 0.09));
                    var lp = 10 * Math.log10(p[Math.max(loBin, i - nw)] + 1e-20);
                    var rp = 10 * Math.log10(p[Math.min(hiBin, i + nw)] + 1e-20);
                    if (db - lp >= 3 && db - rp >= 3) {
                        /* линия резонанса ДЫШИТ (замер: пик гуляет 648..653
                           бинов), а утечка делит тон между соседями — засчёт
                           строго в один бин ронял presence ниже 0.8. Размазка
                           ±2 бина; мелодия шагает полутоном = 5+ бинов, так
                           что защита от движения не слабеет. */
                        for (var sm = Math.max(loBin, i - 2); sm <= Math.min(hiBin, i + 2); sm++) { hits[sm]++; promSum[sm] += prom; }
                    }
                }
            }
        }
        function finish() {
        var i;
        for (i = loBin; i <= hiBin; i++) meanDb[i] /= nFrames;

        // кандидаты: стационарные бины → слить соседние в один резонанс
        var cands = [];
        var minHits = Math.ceil(nFrames * PRESENCE);
        i = loBin;
        while (i <= hiBin) {
            if (hits[i] >= minHits) {
                var j2 = i, bestBin = i;
                while (j2 + 1 <= hiBin && hits[j2 + 1] >= minHits) { j2++; if (promSum[j2] > promSum[bestBin]) bestBin = j2; }
                cands.push({ bin: bestBin, freq: bestBin * binHz, prom: promSum[bestBin] / hits[bestBin], widthBins: j2 - i + 1 });
                i = j2 + 1;
            } else i++;
        }

        // защиты 2 и 3
        function levelNear(freq) {
            var b = Math.round(freq / binHz);
            if (b < loBin || b > hiBin) return -1e9;
            var m = -1e9;
            for (var k = Math.max(loBin, b - 2); k <= Math.min(hiBin, b + 2); k++) if (meanDb[k] > m) m = meanDb[k];
            return m;
        }
        var out = [];
        for (var ci = 0; ci < cands.length; ci++) {
            var c = cands[ci];
            /* Правило «доминанты» удалено ЗАМЕРОМ: на узком спектре игла
               резонанса сама и есть глобальный максимум — правило отбивало
               настоящую грязь (metal/hum-судьи пустели), а орган и арпеджио
               и так держат стационарность + гармоническая семья. Потолок
               −8 дБ ограничивает вред даже теоретической ошибки. */
            var self = meanDb[c.bin];
            var h2 = levelNear(c.freq * 2), h3 = levelNear(c.freq * 3);
            var sub2 = levelNear(c.freq / 2), sub3 = levelNear(c.freq / 3);
            // гармоническая семья вверх И вниз: кандидат может сам быть
            // 3-й гармоникой выдержанной ноты (орган: 991 = 3×330)
            if (h2 > self - 18 || h3 > self - 18 || sub2 > self - 12 || sub3 > self - 12) continue;
            var q = Math.max(4, Math.min(16, c.freq / (Math.max(1, c.widthBins) * binHz * 2)));
            out.push({
                freq: Math.round(c.freq),
                gainDb: -Math.min(MAX_CUT_DB, Math.max(3, c.prom * 0.7)),
                q: Math.round(q * 10) / 10,
                promDb: Math.round(c.prom * 10) / 10
            });
        }
        out.sort(function (a2, b2) { return b2.promDb - a2.promDb; });
        return out.slice(0, MAX_CUTS);
        }
        return { processFrame: processFrame, finish: finish, nFrames: nFrames };
    }

    // Синхронный путь (node-тесты, короткие буферы)
    function analyze(buffer) {
        var st = prepareAnalysis(buffer);
        if (!st) return [];
        for (var f = 0; f < st.nFrames; f++) st.processFrame(f);
        return st.finish();
    }
    // Нарезанный путь для главного потока: FFT-проход на no-SIMD машине —
    // до ~1.5 с сплошняком, а .then — микрозадача (урок folder-zip):
    // настоящая макрозадача каждые 16 кадров.
    async function analyzeAsync(buffer) {
        var st = prepareAnalysis(buffer);
        if (!st) return [];
        for (var f = 0; f < st.nFrames; f++) {
            st.processFrame(f);
            if ((f & 15) === 15) await new Promise(function (r) {
                if (typeof scheduler !== 'undefined' && scheduler.yield) { scheduler.yield().then(r); return; }
                setTimeout(r, 0);
            });
        }
        return st.finish();
    }

    var API = { analyze: analyze, analyzeAsync: analyzeAsync };
    if (typeof module !== 'undefined' && module.exports) module.exports = API;
    if (typeof window !== 'undefined') window.ResonanceTamer = API;
})(typeof globalThis !== 'undefined' ? globalThis : this);
